function Hero() {
  return (
    <header className="bg-light text-center py-5">
      <h1 className="display-4">Soluciones Industriales y Ferreteras para Venezuela</h1>
      <p className="lead">Importamos desde China y Panamá para abastecer con calidad.</p>
      <a href="#contact" className="btn btn-primary mt-3">Contáctanos</a>
    </header>
  );
}

export default Hero;